export default {
  productOptions: [
    "산업용 고무부품",
    "자동차용 고무부품",
    "방진고무",
    "패킹 및 가스켓",
    "압축성형 제품",
    "고무 금형 제품",
    "맞춤 제작 제품",
    "기타 (직접 입력)",
  ],
  page: {
    title: "견적 요청",
    bannerSubtitle: "도면과 요구사항을 보내주시면 최적의 견적을 신속하게 제공해 드립니다",
    submittedSubtitle: "견적 요청이 접수되었습니다",
    submittedTitle: "견적 요청이 접수되었습니다",
    submittedDesc: "담당 엔지니어가 도면과 요청 내용을 검토한 후 2~3 영업일 이내에 견적서를 이메일로 발송해 드립니다. 긴급한 사항은 전화로 연락 부탁드립니다.",
    viewProducts: "제품 보러가기",
    viewTech: "기술자료 보기",
    guideTitle: "견적 의뢰 안내",
    guideDesc: "정확한 견적 산출을 위해 아래 정보를 함께 보내주시면 더욱 신속한 상담이 가능합니다.",
    requiredInfoTitle: "견적 의뢰 시 필요 정보",
    requiredInfo: [
      "제품 도면 또는 스케치 (PDF, DWG, JPG)",
      "필요 수량 (월 예상 소요량)",
      "적용 환경 (온도, 접촉 유체, 압력 등)",
      "요구 물성 (경도, 인장강도, 내열온도 등)",
      "희망 납기",
    ],
    processTitle: "견적 프로세스",
    process: [
      { step: 1, title: "문의 접수", desc: "전화, 이메일, 또는 견적요청 게시판을 통한 접수" },
      { step: 2, title: "도면 검토", desc: "엔지니어의 도면/사양 검토 및 소재 추천" },
      { step: 3, title: "견적서 발송", desc: "2~3 영업일 이내 견적서 이메일 발송" },
      { step: 4, title: "협의 및 조정", desc: "수량·납기·사양 협의 및 최종 견적 확정" },
    ],
    telInquiry: "전화 문의",
    emailInquiry: "이메일 문의",
    onlineTitle: "온라인 견적 요청",
    onlineDesc: "아래 양식을 작성해 주시면 담당 엔지니어가 확인 후 견적서를 발송해 드립니다. * 표시는 필수 입력 항목입니다.",
    form: {
      company: "회사명",
      companyPlaceholder: "회사명을 입력하세요",
      name: "담당자명",
      namePlaceholder: "담당자명을 입력하세요",
      phone: "연락처",
      phonePlaceholder: "연락처를 입력하세요",
      email: "이메일",
      emailPlaceholder: "이메일을 입력하세요",
      productCategory: "제품 분야",
      productCategoryPlaceholder: "제품 분야를 선택하세요",
      productName: "제품명 / 품번",
      productNamePlaceholder: "제품명 또는 품번을 입력하세요",
      quantity: "필요 수량",
      quantityPlaceholder: "예) 월 10,000개 / 초도 500개",
      deadline: "희망 납기",
      deadlinePlaceholder: "예) 2025년 8월 말 / ASAP",
      requirements: "요구사항",
      requirementsPlaceholder: "적용 환경, 요구 물성(경도, 내열온도, 내유성 등), 특이사항 등을 구체적으로 기재해 주세요.",
      maxLengthHint: "최대 500자까지 입력 가능합니다.",
      drawingFile: "도면 파일 첨부",
      drawingFileHint: "PDF, DWG, DXF, JPG, PNG 파일 첨부 가능 (최대 10MB)",
      consent: "개인정보 수집 및 이용에 동의합니다. 수집된 개인정보는 견적 응대 목적으로만 사용되며, 관련 법령에 따라 안전하게 보관됩니다.",
      submit: "견적 요청하기",
      submitting: "접수 중...",
    },
  },
};